import { ToolbarFieldConfig } from "./ToolbarSinisterGeneric";

export const fieldsConfig: ToolbarFieldConfig[] = [
	{
		key: "selectedIdManager",
		label: "Responsável",
		type: "autocomplete",
		options: [],
		extraProps: { sx: { minWidth: 200 } },
		// onChange: (val, _, setFilter) => {
		// 	setFilter("selectedIdManager", val?.id ?? "");
		// 	setFilter("selectedIdClient", "");
		// },
	},
	{
		key: "selectedIdClient",
		label: "Cliente",
		type: "autocomplete",
		options: [],
		//show: (filters) => !!filters.selectedIdManager,
		extraProps: { sx: { minWidth: 200 } },
	},
	{
		key: "createdFrom", // era esse o nome correto
		label: "Origem",
		type: "select",
		defaultValue: "Todos",
		options: [
			{ value: "Todos", label: "Todos" },
			{ value: "web_app", label: "Garantti", extraProps: { sx: { color: "#8446d6" } } },
			{ value: "web_service", label: "Integração" },
		],
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "busyImobile",
		label: "Status de imóvel",
		type: "select",
		options: [
			{ value: "ocupado", label: "Ocupado" },
			{ value: "desocupado", label: "Desocupado" },
			{ value: "Todos", label: "Todos" },
		],
		defaultValue: "Todos",
		extraProps: { sx: { minWidth: 160 } },
	},
	{
		key: "data",
		label: "Data",
		type: "select",
		options: [
			{ value: "hoje", label: "Hoje" },
			{ value: "anterior", label: "Anterior" },
			{ value: "7", label: "Últimos 7 dias" },
			{ value: "15", label: "Últimos 15 dias" },
			{ value: "30", label: "Últimos 30 dias" },
			{ value: "60", label: "Últimos 60 dias" },
			{ value: "90", label: "Últimos 90 dias" },
			{ value: "ano", label: "Ano Atual" },
			{ value: "mes", label: "Mês Atual" },
			{ value: "periodo", label: "Período", extraProps: { sx: { color: "#a268e4" } } }, // cor roxa
		],
		defaultValue: "mes",
		extraProps: { sx: { minWidth: 150 }, size: "small" },
	},
	{
		key: "dataIni",
		label: "Data Inicial",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "dataFim",
		label: "Data Final",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "filterField",
		label: "Pesquisar por",
		type: "select",
		options: [
			{ value: "documento", label: "Documento" },
			{ value: "nome", label: "Nome" },
		],
		defaultValue: "documento",
		extraProps: { sx: { minWidth: 150 } },
		group: "searchBar",
	},
	{
		key: "textSearch",
		label: "Pesquisar",
		type: "text",
		extraProps: {
			placeholder: "Digite para buscar...",
			sx: { minWidth: 350 },
		},
		group: "searchBar",
	},

	{
		key: "isSketch",
		label: "Rascunho",
		type: "switch",
		defaultValue: 0,
		group: "switches",
		show: false, // sinistro não abre mais em rascunho, opção ocultada mas mantida no código
	},
	{
		key: "isLMI",
		label: "LMI sem saldo",
		type: "switch",
		defaultValue: 0,
		group: "switches",
	},

	{
		key: "statusSinister",
		label: "Status",
		type: "select",
		options: [
			{ value: "Todos", label: "Todos" },
			{ value: "open", label: "Abertos" },
			{ value: "in_progress", label: "Em Andamento" },
			{ value: "in_analysis", label: "Em Análise" },
			{ value: "finalized", label: "Finalizados" },
			{ value: "pending", label: "Pendentes" },
			{ value: "debts_confession", label: "Confissão de Dívidas" },
			{ value: "canceled", label: "Cancelados" },
			{ value: "monthly_compensation", label: "Indenizados" },
			{ value: "suspended", label: "Suspensos" },
			{ value: "reversal", label: "Estornados" },
			{ value: "transferred", label: "Repasse" },
			{ isGroup: true, label: "Acordos" }, // <== Grupo visual
			{ value: "preventive", label: "Preventivo", group: "according" },
			{ value: "judicial", label: "Judicial", group: "according" },
			{ value: "extrajudicial", label: "Extrajudicial", group: "according" },
		],
		defaultValue: ["open"],
		extraProps: {
			multiple: true,
			sx: { minWidth: 200 },
			renderValue: (selected: string[]) => {
				const labelMap: Record<string, string> = {
					Todos: "Todos",
					open: "Abertos",
					in_progress: "Em Andamento",
					finalized: "Finalizados",
					pending: "Pendentes",
					debts_confession: "Confissão de Dívidas",
					canceled: "Cancelados",
					monthly_compensation: "Indenizados",
					suspended: "Suspensos",
					reversal: "Estornados",
					transferred: "Repasse",
					preventive: "Preventivo",
					judicial: "Judicial",
					extrajudicial: "Extrajudicial",
				};
				return selected.map((s) => labelMap[s] || s).join(", ");
			},
		},
		group: "status",
	},
];
